export default {
    data: () => ({ uploadingAttachments: false, uploadedAttachmentPaths: [] }),
    beforeDestroy() {
        this.uploadedAttachmentPaths.forEach(path =>
            this.$http2.delete("/api/myconfig/attachments", { params: { path }, headers: { ignoredRequest: true } }).catch(() => {})
        );
    },
    methods: {
        async handleFileChange() {
            const input = this.$refs.editfiles || this.$refs.editfilesResource;
            const files = Array.from(input.files);
            if (this.uploadingAttachments || !files.length) return;
            this.uploadingAttachments = true;
            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            try {
                for (const file of files) {
                    if (!file.size || file.size > 250 * 1024 * 1024)
                        throw new Error("Selecione um arquivo de até 250 MB.");
                    const form = new FormData();
                    form.append("file", file);
                    const { data } = await this.$http2.post("/api/myconfig/attachments", form);
                    this.uploadedAttachmentPaths.push(data.data.file);
                    this.attachments.push({ ...data.data, ...this.getFileDetails(file.type) });
                }
            } catch (error) {
                this.showToast(this.$t("Error"), "FrownIcon", error.message, "danger");
            } finally {
                input.value = "";
                this.uploadingAttachments = false;
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
            }
        }
    }
};
